import { render, staticRenderFns } from "./coursesList.vue?vue&type=template&id=4b578893&"
import script from "./coursesList.vue?vue&type=script&lang=js&"
export * from "./coursesList.vue?vue&type=script&lang=js&"
import style0 from "./coursesList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports